import {
	Id,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import { ICampaignUrlIndexResource, ICampaignUrlRequest } from "../types";

export const createCampaignUrlService = (id: Id) => {
	const baseKey = ["campaigns", `${id}`, "urls"];
	return {
		...withIndexEndpoint<ICampaignUrlIndexResource>([...baseKey]),
		...withShowEndpoint<ICampaignUrlIndexResource>(baseKey),
		...withStoreEndpoint<ICampaignUrlRequest>(baseKey),
		...withUpdateEndpoint<ICampaignUrlRequest>(baseKey),
		...withDestroyEndpoint(baseKey),
	};
};
